import * as React from 'react';
import useClient from '../../hooks/useClient';
import SurveyEditor from '../../components/SurveyEditor/SurveyEditor';
import { UpdateSiteSurveyCommand } from '../../helpers/ApiResources';
import { useParams } from 'react-router';

const SurveyEditorCreatePage: React.FC = () => {

  const client = useClient();
  const params: any = useParams();

  const handleSubmit = (data: UpdateSiteSurveyCommand) => {
    return client.siteSurvey_Create(data);
  }

  return (
    <SurveyEditor onSubmit={handleSubmit} />
  );
}

export default SurveyEditorCreatePage;